import { useEffect, useState } from "react";
import { useCentralStore } from "../../store/appContext";
import ActionTypes from "../../store/actionTypes";
import { useNavigate } from "react-router-dom";
import API from "../../api";
import OtpPage from "./otp";
import Spinner from "../../components/common/spinner/spinner";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Image } from "antd";
import classNames from "classnames";
import { jwtDecode } from "jwt-decode";
import { getCarrierByDomain } from "../../domain";
import AuthService from "../../utils/authSerivce";
import config from "../../config/config";
import LockIcon from '../../assets/icons/password-lock'
import Popup from "../../components/common/popup/popup";
import CrossIcon from "../../assets/icons/cross-icon";
const CryptoJS = require('crypto-js');

const LoginForm = ({ }) => {
  const [{ userLoggedIn, email, password, loadingData, carrierThemeData }, dispatch] = useCentralStore();
  const [loginerror, setLoginerror] = useState()
  const [emailerror, setEmailerror] = useState()
  const [passworderror, setPasswordError] = useState()
  const [forgotPasslinkflag, setForgotPasslinkflag] = useState(false)
  const [Otp,setOtp] = useState()
  const [newPassword,setNewPassword] =useState()
  const [confirmPassword,setConfirmPassword] =useState()
  const [otpSuccessFlag,setOtpSuccessFlag] =useState()
  const plainText = confirmPassword;
  
  // Define a secret key (keep it secure in production!)
  const secretKey = '3455F8EB1B9511E8B77B0ADC30863E72';
  
  function encryptData(plainText, key) {
    const ciphertext = CryptoJS.AES.encrypt(plainText, key).toString();
    return ciphertext;
  }
  
  const encrypted = encryptData(plainText, secretKey);
  console.log('Encrypted:', encrypted);

  const navigate = useNavigate();

  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING_DATA, payload: action });
  };

  const validateEmail = (values) => {
    const errors = {}

    if (!values) {
      setEmailerror('Email Address Required')
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values)) {
      setEmailerror('Invalid Email address')
    } else {
      setEmailerror('')
    }
    return errors
  }
  const validatePassword = (values) => {
    const errors = {}

    if (!values) {
      setPasswordError('Password is Required')
    } else {
      setPasswordError('')
    }
    return errors
  }

  const Email = (e) => {
    let emailValue= e && e.target && e.target.value;
    setLoginerror('')
    setPasswordError('')
    dispatch({
      type: ActionTypes.SET_EMAIL_ADDRESS,
      payload: emailValue,
    });
    validateEmail(emailValue)
  };
  const Password = (e) => {
    setLoginerror('')
    setPasswordError('')
    dispatch({
      type: ActionTypes.SET_PASSWORD,
      payload: e.target.value,
    });
    validatePassword(e.target.value)
  };

   const handleOtp= (e)=>{
        setOtp(e.target.value,)
      }
  const handleNewPassword  = (e) => {
        setNewPassword(e.target.value,)
        validatePassword(e.target.value)
  };

  const handleConfirmPassword  = (e) => {
    setConfirmPassword(e.target.value,)
    validatePassword(e.target.value)
  };
  const forgotPassword = () => {
            if(newPassword === confirmPassword){
                setLoading(true)
                let request = {
                    email: email, 
                    confirmationCode: Otp,  
                    newPassword: encrypted
                  }
                    
                API[ActionTypes.UPDATE_FORGOT_PASSWORD](request)
                .then((data) => {
                    setLoading(false)
                    navigate("/");
                    })
                .catch((err) => {
                    setLoading(false)
                    console.log(`error is ${err}`);
                    setPasswordError('Something went wrong')
                    });

            }else {
                setPasswordError('Password not matching')
                setOtp('');
                setNewPassword('');
                setConfirmPassword('');
            }
  }
  const closeAllflag= ()=>{
            setForgotPasslinkflag(false);
            setOtpSuccessFlag(false)
            setOtp('');
            setNewPassword('');
            setConfirmPassword('');
            setPasswordError('')
            setEmailerror('')
  }
  const sendOtp=()=>{
            if(email){
                setLoading(true)
                API[ActionTypes.SEND_OTP](email)
                .then((data) => {
                    setOtpSuccessFlag(true)
                    setForgotPasslinkflag(false);
                    setLoading(false)
                    })
                .catch((err) => {
                    setLoading(false)
                    setForgotPasslinkflag(true);
                    setOtpSuccessFlag(false)
                    console.log(`error is ${err}`);
                    setPasswordError('Something went wrong')
                    });

            }else {
                setPasswordError('Something went wrong')
            }
  }
  useEffect(() => {
    if (userLoggedIn) {
      OtpPage();
    }
  }, [userLoggedIn]);

  const login = () => {
    setLoading(true)
    //  API[ActionTypes.OTP_REQUEST]("mrunal.deshmukh@asurion.com", "Madhavi@123")
    let payload = {
      GetUserDetailRequest: {
        email: email
      }
    }
    API[ActionTypes.GET_USER_DETAILS](payload)
        .then((userData) => {
          if(userData?.data?.Attributes?.Value?.toLowerCase() === getCarrierByDomain()?.toLowerCase()) {
            let abc= API[ActionTypes.VALIDATE_EMAIL_PASSWORD];
            API[ActionTypes.VALIDATE_EMAIL_PASSWORD](email, password)
            .then((data) => {
              setLoading(false);
              if (data?.challengeName === 'NEW_PASSWORD_REQUIRED') {
                navigate('/changePassword')
              } else if (data?.challengeName === 'CUSTOM_CHALLENGE') {
                dispatch({
                  type: ActionTypes.SET_USER_LOGGED_IN,
                  payload: true,
                });
                navigate("/otpPage");
              }
            })
            .catch((err) => {
              setLoading(false)
              if (err) {
                setLoginerror('Invalid Username or Password')
              }
              console.log(`error is ${err}`);
            });
          } else {
            setLoading(false);
            setLoginerror('User not allowed to login!')
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(`error is ${err}`);
          setLoginerror('User not allowed to login!')
        })


    // API[ActionTypes.VALIDATE_EMAIL_PASSWORD](email, password)
    //   .then((data) => {
    //     API[ActionTypes.GET_USER_DETAILS](payload)
    //     .then((userData) => {
    //       setLoading(false);
    //       if(userData?.data?.Attributes?.Value?.toLowerCase() === getCarrierByDomain()?.toLowerCase()) {
    //         if (data?.challengeName === 'NEW_PASSWORD_REQUIRED') {
    //           navigate('/changePassword')
    //         } else if (data?.challengeName === 'CUSTOM_CHALLENGE') {
    //           dispatch({
    //             type: ActionTypes.SET_USER_LOGGED_IN,
    //             payload: true,
    //           });
    //           navigate("/otpPage");
    //           // console.log('OTP Page', data);
    //           // dispatch({
    //           //   type: ActionTypes.SET_USER_DATA,
    //           //   payload: { access_token: idToken }
    //           // });
    //           // dispatch({
    //           //   type: ActionTypes.SET_USER_DETAILS,
    //           //   payload: email
    //           // });
    
    //         // }
    //       }
    //       } else {
    //         setLoginerror('User not allowed to login!')
    //       }

    //     })
    //     .catch((err) => {
    //       setLoading(false);
    //       console.log(`error is ${err}`);
    //       setLoginerror('User not allowed to login!')
    //     })
    //   })
    //   .catch((err) => {
    //     setLoading(false)
    //     if (err) {
    //       setLoginerror('Invalid Username or Password')
    //     }
    //     console.log(`error is ${err}`);
    //   });

  }

  const { theme } = carrierThemeData;

  const dynamicStyle = {
    '--dynamic-color': theme?.colors?.primary,
    // '--font-color': theme?.colors?.textWhiteColor,
    '--background-color': theme?.colors?.primary
};

  return (<>
    {loadingData && <Spinner showOverlay={true} />}
    {carrierThemeData && <div className="bg-white h-screen text-black"
    // style={{ 
    //   background: `${theme?.colors?.primary} url(${theme?.backgroundImg})`
    //  }}
     >
      <div className="background-container">
        {/* <div className="boxone" style={dynamicStyle}></div>
        <div className="box" style={dynamicStyle}></div> */}
        <div className="flex justify-between">
          <div className="content">
            <img className="mx-auto h-20" src={theme?.logo} />
            {/* <Image className="mx-auto mt-28 h-32 w-32" src={require(`${theme?.logo}`)} /> */}
            <div className={``}>
              <div className={`Logintitle text-center`}>
                <p className={`texts`}>
                  Sign in and start managing your
                  <p className={`textfonts`}>{carrierThemeData?.program}</p>
                </p>
              </div>
              <br></br>
              <div class="relative">
                <input
                  type="text"
                  id="floating_outlined"
                  class="block  px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer"
                  placeholder="Email Address"
                  defaultValue={email}
                  onChange={Email}
                  disabled={forgotPasslinkflag || otpSuccessFlag}
                />
                <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 color:gray">Email Address</label>
              </div>
              <br />
              <div class="relative">
                {/* <LockIcon className="absolute" /> */}
                <input
                  type="password"
                  id="floating_outlined"
                  class="block  px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer"
                  placeholder="Password"
                  defaultValue={password}
                  onChange={Password}

                />
                <label for="floating_outlined" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 text-gray-100">
                  Password
                </label>
              </div>
              <div className="mt-5 mx-m15 flex justify-center">
                <button
                  id="continue"
                  onClick={login}
                  className={`px-4 py-2 w-full rounded-xs backgroundStyle ${getCarrierByDomain()?.toLowerCase() === 'celcom' ? 'text-white' : 'textFontStyle'} font-bold text-sm`}
                  type="submit"
                  style={dynamicStyle}
                // disabled={logindisable}
                >
                  Login
                </button>
              </div>
              <div>
              <div 
                className="text-sm mt-4 text-center underline text-blue-600 hover:text-blue-800 visited:text-purple-600 cursor-pointer" 
                onClick={()=>{setForgotPasslinkflag(true);Email('')}}> Forgot Password</div>
               <>
              <Popup
                show={forgotPasslinkflag || otpSuccessFlag}
                global={true}
                fitContent={true}
                emailPopup={true}
                onClose={() => setForgotPasslinkflag(false)}
                definationsPopup={true}
                resetPass={true}
              >
               <div className="p-4 pb-6 rounded-xl" style={{height: "auto !important"}}>
                  <div className="flex justify-end mb-2">
                    <CrossIcon className="cursor-pointer" 
                    onClick={() => {closeAllflag()}} />
                  </div>
                {forgotPasslinkflag && <div>
                  <div class="relative mb-5 w-full">
                    <input
                      type="text"
                      id="floating_outlined"
                      class="block  px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer"
                      placeholder="Email Address"
                      value={email}
                      onChange={Email}
                      disabled={otpSuccessFlag}
                    />
                    <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 color:gray">Email Address</label>
                  </div>
                  <div className="mt-5 mx-m15 flex justify-center">
                    <button
                        id="continue"
                        onClick={() => {sendOtp()}}
                        className={`px-4 py-2 w-full rounded-lg backgroundStyle text-white text-sm`}
                        style={dynamicStyle}
                        type="submit"
                        disabled={!email || emailerror}
                        >
                        Send OTP
                    </button>
                  </div>
                    {emailerror  && forgotPasslinkflag && <p className="error text-sm">{emailerror}</p>}
                    {passworderror && forgotPasslinkflag && !emailerror && !loginerror && <p className="error text-sm">{passworderror}</p>}
                  </div>
                }
                {otpSuccessFlag && <div>
                  <div className="text-xs mb-2 font-bold">OTP sent to {email},Please check.<br/></div>
                  <div class="relative">
                    <input 
                    type="text" 
                    id="floating_outlined"
                    class="block  px-2.5 pb-2.5 pt-4 w-[300px] text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer" 
                    placeholder="OTP"  
                    value={Otp}
                    onChange={handleOtp}
                    />
                    <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 color:gray">Enter OTP</label>
                  </div>
                  <div class="relative mt-5">
                    <input 
                    type="password" 
                    id="floating_outlined"
                    class="block  px-2.5 pb-2.5 pt-4 w-[300px] text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer" 
                    placeholder="Password"  
                    value={newPassword}
                    onChange={handleNewPassword}
                    />
                    <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 color:gray">Enter New Password</label>
                  </div>
                  <div class="relative mt-5">
                      <input 
                      type="password" 
                      id="floating_outlined"
                      class="block  px-2.5 pb-2.5 pt-4 w-[300px] text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer" 
                      placeholder="Password"  
                      value={confirmPassword}
                      onChange={handleConfirmPassword}
                      />
                      <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 color:gray">Confirm Password</label>
                  </div>
                  <div className="mt-5 mx-m15 flex justify-center">
                    <button
                        id="continue"
                        onClick={() => forgotPassword()}
                        className={`px-4 py-2 w-full rounded-lg backgroundStyle text-white text-sm`}
                        style={dynamicStyle}
                        type="button"
                        disabled={!Otp || !newPassword || !confirmPassword}
                        >
                        Change Password
                    </button>
                  </div>
                  <div>
                    {passworderror && (forgotPasslinkflag || otpSuccessFlag) &&
                    <p className="error text-sm">{passworderror}</p>
                    }
                  </div>
                </div>}
                </div>
              </Popup>
            </>
            </div>
              {loginerror && !forgotPasslinkflag && <p className="error">{loginerror}</p>}
              {emailerror && !loginerror && !forgotPasslinkflag  && <p className="error">{emailerror}</p>}
              {passworderror && !forgotPasslinkflag && !otpSuccessFlag && !emailerror && !loginerror && <p className="error">{passworderror}</p>}
            </div>
          </div>
          <div className="flex justify-end w-1/2">
            <LazyLoadImage
              className="h-screen"
              // alt={image.alt}
              loading="lazy"
              // src={require('../../assets/icons/LaptopLogin.png')} />
              src={require('../../assets/icons/LoginImg.png')} />
          </div>
        </div>
      </div>
    </div>}
  </>
  );
};

export default LoginForm;
